import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { IconCheckmark } from '../../components';

import css from './CancellationBanner.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @returns {JSX.Element} "add" icon
 */
const CancellationBanner = props => {
  const { className } = props;
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>

      <div className={css.icon}>
        <IconCheckmark size="small" />
      </div>
      <div className={css.text}>
        <p className={css.textTop}>
          <FormattedMessage id="CancellationBanner.textTop" />
        </p>
        <p className={css.textBottom}>
          <FormattedMessage id="CancellationBanner.textBottom" />
        </p>
      </div>
    </div>
  );
};

export default CancellationBanner;
